import readRequiredStringEnv from './services/readRequiredStringEnv';

export default readRequiredStringEnv(process.env.NEXT_PUBLIC_BASE_URL, 'NEXT_PUBLIC_BASE_URL');
